import { render } from "./CheckMark.vue?vue&type=template&id=238b61aa"
const script = {}
script.render = render

export default script